import CloudinaryService from "@/core/services/cloudinary.service";

export default {
  install(Vue) {
    const cloudinary = CloudinaryService.init();

    Vue.prototype.$cloudinary = cloudinary;
    Vue.prototype.$cloudinaryConfig = CloudinaryService.getConfig();

    Vue.mixin({
      computed: {
        $cld() {
          return cloudinary;
        }
      }
    });
  }
};
